import ReactDOM from "react-dom/client";
import "./interceptors/axiosIntercepter.ts";
import Main from "./main.tsx";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// Fixes Issue: https://github.com/wojtekmaj/react-pdf/issues/1811#issuecomment-2171019115
if (typeof Promise.withResolvers === "undefined") {
  Object.defineProperty(Promise, "withResolvers", {
    configurable: true,
    writable: true,
    value: function () {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    },
  });
}

// Adding worker for display PDFs
// Use CDN for worker to avoid MIME type issues in production
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

ReactDOM.createRoot(document.getElementById("root")!).render(<Main />);
